import React, { Fragment, PureComponent } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

/* eslint frontbucket-patterns/no-old-dropdown-menu: "warn" */
import { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';

import urls from 'src/urls/source';

import { RepositoryPrivilege } from '../../../types';

import messages from './file-actions-menu.i18n';
import MoreMenu from './more-menu';

type Props = {
  hash: string;
  intl: InjectedIntl;
  isAtHead?: boolean;
  onDelete?: () => void;
  onOpenRaw?: () => void;
  onRename?: () => void;
  onToggleAnnotate?: () => void;
  path: string;
  repositoryAccessLevel?: RepositoryPrivilege;
  repositoryFullSlug: string;
  userIsAnonymous: boolean;
};

class FileActionsMenu extends PureComponent<Props> {
  static defaultProps = {
    isAtHead: false,
    onDelete: () => {},
    onOpenRaw: () => {},
    onRename: () => {},
    onToggleAnnotate: () => {},
  };

  render() {
    const {
      hash,
      intl,
      isAtHead,
      path,
      repositoryAccessLevel,
      repositoryFullSlug,
      userIsAnonymous,
    } = this.props;

    const deleteLabel = intl.formatMessage(messages.deleteAction);
    const deleteLabelDisabled = intl.formatMessage(
      messages.deleteActionDisabled
    );
    const renameLabel = intl.formatMessage(messages.renameAction);
    const renameLabelDisabled = intl.formatMessage(
      messages.renameActionDisabled
    );

    const readOnlyUser = repositoryAccessLevel === 'read';

    return (
      <MoreMenu label={intl.formatMessage(messages.menuLabel)}>
        <DropdownItemGroup>
          <DropdownItem onClick={this.props.onToggleAnnotate}>
            {intl.formatMessage(messages.toggleAnnotateAction)}
          </DropdownItem>
          <DropdownItem
            href={urls.ui.raw(repositoryFullSlug, hash, path)}
            onClick={this.props.onOpenRaw}
            target="_blank"
          >
            {intl.formatMessage(messages.openRawAction)}
          </DropdownItem>
          {!userIsAnonymous && (
            <Fragment>
              <DropdownItem
                isDisabled={!isAtHead || readOnlyUser}
                onClick={this.props.onRename}
                title={isAtHead ? renameLabel : renameLabelDisabled}
              >
                {renameLabel}
              </DropdownItem>
              <DropdownItem
                isDisabled={!isAtHead || readOnlyUser}
                onClick={this.props.onDelete}
                title={isAtHead ? deleteLabel : deleteLabelDisabled}
              >
                {deleteLabel}
              </DropdownItem>
            </Fragment>
          )}
        </DropdownItemGroup>
      </MoreMenu>
    );
  }
}

export default injectIntl(FileActionsMenu);
